import React from 'react';
import PropTypes from "prop-types";
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Slide from '@material-ui/core/Slide';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
    minWidth: 550,
    maxWidth: 500
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, hideClose, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {!hideClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const ControlledDialog = props => {
  const { handleClose, open, title, content, isFullScreen, disableBackdropClick, actions, disableEscapeKeyDown, disableScrollLock, hideClose, dividers } = props;
  return (
    <div>
      <Dialog disableBackdropClick={disableBackdropClick} disableScrollLock={disableScrollLock}
        disableEscapeKeyDown={disableEscapeKeyDown} fullScreen={isFullScreen} onClose={handleClose}
        aria-labelledby="customized-dialog-title" open={open} TransitionComponent={Transition} >
        <DialogTitle id="customized-dialog-title" hideClose={hideClose} onClose={handleClose}>
          {title}
        </DialogTitle>
        <DialogContent dividers={dividers}>
          <Typography gutterBottom>
            {content}
          </Typography>
        </DialogContent>
        <DialogActions>
          {actions}
        </DialogActions>
      </Dialog>
    </div>
  );
}

ControlledDialog.propTypes = {
  title: PropTypes.any,
  handleClose: PropTypes.func,
  open: PropTypes.bool,
  isFullScreen: PropTypes.bool,
  disableBackdropClick: PropTypes.bool,
  disableEscapeKeyDown: PropTypes.bool,
  disableScrollLock: PropTypes.bool,
  hideClose: PropTypes.bool,
  content: PropTypes.any,
  actions: PropTypes.any,
  dividers: PropTypes.bool
};

ControlledDialog.defaultProps = {
  title: <span></span>,
  open: false,
  content: "",
  handleClose: fn => fn,
  isFullScreen: false,
  actions: "",
  disableBackdropClick: false,
  disableEscapeKeyDown: false,
  disableScrollLock: false,
  hideClose: false,
  dividers: false
};

export default ControlledDialog;